import { render, staticRenderFns } from "./PainelDocumentoSolicitadoEdicao.vue?vue&type=template&id=ca5121fe&scoped=true"
import script from "./PainelDocumentoSolicitadoEdicao.vue?vue&type=script&lang=js"
export * from "./PainelDocumentoSolicitadoEdicao.vue?vue&type=script&lang=js"
import style0 from "./PainelDocumentoSolicitadoEdicao.vue?vue&type=style&index=0&id=ca5121fe&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5121fe",
  null
  
)

export default component.exports